import { Cliente } from "./Cliente";
import ItensPedido from "./ItensPedido";
import IPagamentosPedido from "./PagamentosPedido";

export default interface Pedido {
  id: number;
  valorTotal: number;
  dataCriacao: string;
  formaPagamento: string;
  quantidadeParcelas: number;
  observacoes: string;
  cliente: Cliente;  
  itensPedido: ItensPedido[];
  pagamentosPedido: IPagamentosPedido[];
}
export interface FiltroPesquisarPedido {
  idPedido: number | null;
  nomeCliente: string;
  dataInicial: string | null;
  dataFinal: string | null;
}

export interface FiltroRelatorio {
  dataInicial: string | null;
  dataFinal: string | null;
}

export const estadoInicialFiltroPesquisarPedido: FiltroPesquisarPedido = {
  idPedido: null,
  nomeCliente: "",
  dataInicial: null,
  dataFinal: null,
};
